import { get } from './api';
import { TicketRequestSubcategoryI } from 'declarations/interfaces/ticketRequestSubcategories';

export const getTicketRequestSubCategories = async () => {
  const response = await get<TicketRequestSubcategoryI[]>(`/tickets/sub-categories`);

  return response.data;
};
